import React from "react";
import { connect } from "react-redux";
import API from "../../network";
import ViewRenderer from "./views";
import * as SignInActions from "src/store/actions/SignInActions/SignInAction";
import * as feedActions from "src/store/actions/feedactions/feedActionCreator";
import { withCommunity } from "src/HOC/withCommunity";
import { clearEmailAction } from "src/store/actions/emailTemplatesActions/emailTempActions";
import * as SigInOutActions from "src/store/actions/SignInActions/SignInAction.js";
import Cookies from 'js-cookie';

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      landApiData: {},
      isLandApiDataSet: false,
      feedData: {},
      contributors: [],
      trendingAsks: [],
      trendingTags: [],
      allTags: [],
      allAsks: [],
      allTagData: {},
      userSettings: {},
      filterType: "",
      isNotificationSelected: false,
      showData: "feed",
      searchData: {},
      searchParam: "",
      selectedTagDetails: {},
      showModalForUpdate: false,
      modalTypeForUpdate: "",
      selectedCommunity: {},
      childSaysData: {},
      followData: {},
      voteUpStatus: {},
      loading: false,
      answersToYourAsk: {},
      asksToBeAnswered: {},
      privateTagsData: [],
      childSaysLoading: false,
      feedPageNumber: 1,
      value: 0,
      hasRestrictionSays: false,
      hasRestrictionSaysStatus: "",
      clearSearchHeader: false,
      mounted: false,
      trendingAskBreadCountLength: 1,
      trendingTagBreadCountLength: 1,
      hashMoreTrendingAsks: true,
      hasMoreTrendingTags: true,
      isPostSearching: false,
      showSearchPostPopup: false,
      possibleAsksAndAnswerLoading: false,
      showInviteMismatchModal: false,
      invitedEmail: "",
      loggedInEmail: "",
      followSuccessModal: false,
      followSuccessCommunityName: "",
      showFollowHashtagAlert: false,
      pmRoleModalOpen: false,
      pmRoleModalMessage: "",
    };
  }

  handleUnfollowedEmailCommunity = async (emailAction) => {
      if (emailAction?.action === "InviteFriend") {
        return false;
      }
     const response = await API.fetchLoginUser();
     const userDetails = response?.data;

    const tenantId = emailAction?.tenantId;
    const tenantName = emailAction?.tenantName;

    if (!tenantId || !tenantName) {
      return false;
    }

    const communityFollowNames =
      userDetails?.userData?.communityFollowNames || [];

    const isFollowing = communityFollowNames.some(
      (community) => Number(community?.id) === Number(tenantId),
    );

    if (isFollowing) {
      return false;
    }

    try {
      const response = await API.viewActivityCommunity(tenantName, tenantId);

      if (response) {
        // NEW: Restore the user's default community in context before
        // going to ViewActivity. ViewActivity does not use communityContext,
        // but HomePage uses it when the user comes back.
        const defaultTenantId = userDetails?.userData?.defaultUserTenantId;
        const defaultTenantName = userDetails?.userData?.defaultUserTenant;

        if (defaultTenantId && defaultTenantName) {
          this.props.communityContext?.onChangeCommunity({
            tenantId: defaultTenantId,
            tenantName: defaultTenantName,
          });
        }
        this.props.dispatchClearEmailAction();
        this.props.history.push("/ViewActivityAfterSignIn", {
          community: tenantName,
          tenantId: tenantId,
          email: emailAction?.emailId,
          password: "",
          displayName: "",
          signIn: true,
          communityType: "",
          defaultCountry: "",
          fromEmailAction: true,
        });

        return true;
      }
    } catch (error) {
      console.error("Error loading community activity:", error);
    }

    return false;
  };

  async componentDidMount() {
    const {
      dispatchSettings,
      dispatchUserDetails,
      signInLandApiData,
      emailAction,
    } = this.props;
    this.setState({ mounted: true });
    dispatchSettings();
    const redirectedToViewActivity =
      await this.handleUnfollowedEmailCommunity(emailAction);

    if (redirectedToViewActivity) {
      return;
    }
    // dispatchUserDetails();
    // this.fetchUserDetails();

    // ---------------------------------------------------------
    // NEW: Handle email community action for already logged-in user
    // ---------------------------------------------------------

    if (
      emailAction?.action === "userModeratorRequest" ||
      emailAction?.action === "moderatorPendingItems" ||
      emailAction?.action === "flaggedPost"
    ) {
      window.location.href =
        `/Moderator?tenantId=${emailAction?.tenantId}` +
        `&action=${emailAction?.action}` +
        `&tenantName=${encodeURIComponent(emailAction?.tenantName || "")}`;

      return;
    }

    if (
      emailAction?.action === "InviteFriend" ||
      emailAction?.action === "redirectToCommunity"
    ) {
      await this.handleEmailCommunityAction();
      this.fetchUserDetails();
    } else if (emailAction?.action === "followHashtag") {
      this.handleFollowHashtagEmailAction();
    } else if (
      emailAction?.action === "acceptPMRole" ||
      emailAction?.action === "rejectPMRole" ||
      emailAction?.action === "acceptMRole" ||
      emailAction?.action === "rejectMRole"
    ) {
      this.handlePmRoleEmailAction();
      this.fetchUserDetails();
    } else {
      // Normal HomePage flow
      this.fetchUserDetails();
    }

    // Use signInLandApiData once to initialize local state
    if (signInLandApiData && Object.keys(signInLandApiData).length > 0) {
      this.setState({ landApiData: signInLandApiData });
    }

    // this.setState({ loading: true });
    // dispatchUserDetails();
    // setTimeout(() => {
    //   this.fetchFeedData();
    //   this.fetchContributors();
    //   this.fetchTrendingTags();
    //   this.fetchTrendingAsks();
    // }, 1000);

    // dispatchSettings();
    // this.setState({
    //   selectedCommunity: {
    //     tenantName: userDetails?.userData?.tenantName || "",
    //     tenantId: userDetails?.userData?.tenantId
    //   },
    // });
  }

  componentDidUpdate(prevProps) {
    const { signInLandApiData } = this.props;

    // Only update if:
    // 1. It's not already set
    // 2. New data is non-empty
    // 3. It has changed from previous props
    if (
      !this.state.isLandApiDataSet &&
      signInLandApiData &&
      Object.keys(signInLandApiData).length > 0 &&
      JSON.stringify(signInLandApiData) !==
        JSON.stringify(prevProps.signInLandApiData)
    ) {
      this.setState({
        landApiData: signInLandApiData,
        isLandApiDataSet: true,
      });
    }
  }

  updateTrendingAskPageCount = () => {
    this.setState(
      (prevState) => ({
        trendingAskBreadCountLength: prevState.trendingAskBreadCountLength + 1,
      }),
      () => {
        this.fetchAllAsks();
      },
    );
  };

  updateTrendingTagPageCount = () => {
    this.setState(
      (prevState) => ({
        trendingTagBreadCountLength: prevState.trendingTagBreadCountLength + 1,
      }),
      () => {
        this.fetchAllTags();
      },
    );
  };

  // componentWillReceiveProps(nextProps) {
  //   const { settingsData: prevSettingsData } = this.props || {};
  //   const { settingsData: currentSettingsData, communityContext, location } = nextProps || {};
  //   const { setCommunityToDefault } = location?.state || {};

  //   if (currentSettingsData?.userTenantId && prevSettingsData?.userTenantId !== currentSettingsData?.userTenantId) {
  //     if (communityContext?.community?.tenantId && !setCommunityToDefault) {
  //       this.onCommunityChange(communityContext?.community?.tenantId, communityContext?.community?.tenantName);
  //     } else {
  //       const { userTenantId, userTenant } = currentSettingsData || {};
  //       this.onCommunityChange(userTenantId, userTenant);
  //     }
  //   }
  // }

  fetchIntialData = async () => {
    try {
      this.fetchFeedData();
      this.fetchContributors();
      this.fetchTrendingTags();
      this.fetchTrendingAsks();
    } catch (e) {
      console.error(e);
    }
  };

  deleteAnswersToAsksDialogPost = (id) => {
    const { answersToYourAsk } = this.state;
    const newAnswersToYourAsksList = answersToYourAsk.messageList.filter(
      (item) => item.id !== id,
    );

    // Update the state correctly
    this.setState({
      answersToYourAsk: {
        ...answersToYourAsk, // Spread the existing answersToYourAsk properties
        messageList: newAnswersToYourAsksList, // Update the messageList with the filtered list
      },
    });
  };

  deletePossibleAnswerToAskPost = (postId) => {
    const { answersToYourAsk } = this.state;
    const newAnswersToYourAsksList = answersToYourAsk.messageList.filter(
      (item) => item.Parent_ID !== postId,
    );

    // Update the state correctly
    this.setState({
      answersToYourAsk: {
        ...answersToYourAsk, // Spread the existing answersToYourAsk properties
        messageList: newAnswersToYourAsksList, // Update the messageList with the filtered list
      },
    });
  };

  deleteAsksToBeAnsweredDialogPost = (id) => {
    const { asksToBeAnswered } = this.state;
    const newAnswersToYourAsksList = asksToBeAnswered.messageList.filter(
      (item) => item.id !== id,
    );

    // Update the state correctly
    this.setState({
      asksToBeAnswered: {
        ...asksToBeAnswered, // Spread the existing answersToYourAsk properties
        messageList: newAnswersToYourAsksList, // Update the messageList with the filtered list
      },
    });
  };

  handleFollowSuccessModalClose = () => {
    this.setState(
      {
        followSuccessModal: false,
        followSuccessCommunityName: "",
      },
      () => {
        // Clear email action only after follow popup is closed
        this.props.dispatchClearEmailAction?.();
      },
    );
  };

  showFollowSuccessModal = (communityName) => {
    this.setState({
      followSuccessModal: true,
      followSuccessCommunityName: communityName,
    });
  };

  fetchFeedData = async (filterType) => {
    const { feedPageNumber } = this.state;
    const newPageNumber = (feedPageNumber - 1) * 10;
    try {
      this.setState({ loading: true });
      // const startLimit = 0;
      const response = await API.fetchFeedData(filterType, newPageNumber);
      this.setState({ feedData: response.data, loading: false });
      console.log("getFeedData", response);
    } catch (e) {
      this.setState({ loading: false });
      console.error(e);
    }
  };

  fetchPageFeed = (pageNumber, filterType) => {
    this.setState({ feedPageNumber: pageNumber }, () => {
      this.fetchFeedData(filterType);
    });
  };

  fetchContributors = async () => {
    try {
      const response = await API.fetchContributors();
      this.setState({ contributors: response.data });
      console.log("fetchContributors", response);
    } catch (e) {
      console.error(e);
    }
  };

  fetchTrendingTags = async () => {
    this.setState({ loading: true });
    try {
      const response = await API.fetchTrendingTags();
      this.setState({
        trendingTags: response.data.trendingTags,
        loading: false,
      });
      console.log("fetchTrendingTags", response);
    } catch (e) {
      this.setState({ loading: false });
      console.error(e);
    }
  };

  fetchSelectedTagDetails = async (tagId) => {
    const { selectedCommunity } = this.state;
    const tenantId = selectedCommunity.tenantId;
    const response = await API.fetchTagDetails(tenantId, tagId);
    setTimeout(() => {
      this.setState({ selectedTagDetails: response.data.messageList });
    }, 1000);
  };

  fetchTrendingAsks = async () => {
    this.setState({ loading: true });
    try {
      const response = await API.fetchTrendingAsks();
      this.setState({
        trendingAsks: response.data.trendingAsks,
        loading: false,
      });
      console.log("fetchTrendingAsks", response);
    } catch (e) {
      this.setState({ loading: false });
      console.error(e);
    }
  };

  fetchAllTags = async () => {
    const { trendingTagBreadCountLength } = this.state;
    const newPage = (trendingTagBreadCountLength - 1) * 10;
    this.setState({ loading: true });
    try {
      const response = await API.fetchAllTags(newPage);
      console.log("fetchAllTags", response);
      const newTags = response?.data?.trendingTags || [];
      if (newTags.length > 0) {
        this.setState((prevState) => ({
          allTags: [...newTags],
          allTagData: response.data,
          hasMoreTrendingTags: true,
          loading: false, // Stop loading after success
        }));
      } else {
        this.setState({
          hasMoreTrendingTags: false,
          loading: false, // Stop loading after no more data
        });
      }
    } catch (e) {
      this.setState({ loading: false });
      console.error(e);
    }
  };

  fetchAllAsks = async () => {
    const { trendingAskBreadCountLength } = this.state;
    console.log(`trendingAskBreadCountLength:`, trendingAskBreadCountLength);
    const newPage = (trendingAskBreadCountLength - 1) * 10;
    this.setState({ loading: true });
    try {
      const response = await API.fetchAllAsks(newPage);
      const newAsks = response?.data?.trendingAsks || [];
      if (newAsks.length > 0) {
        this.setState((prevState) => ({
          allAsks: [...newAsks],
          hashMoreTrendingAsks: true,
          loading: false, // Stop loading after success
        }));
      } else {
        this.setState({
          hashMoreTrendingAsks: false,
          loading: false, // Stop loading after no more data
        });
      }
    } catch (e) {
      this.setState({ loading: false });
      console.error(e);
    }
  };

  fetchUserSettings = async () => {
    try {
      const response = await API.fetchUserSettings();
      this.setState({ userSettings: response.data });
      console.log("fetchUserSettings", response);
    } catch (e) {
      console.error(e);
    }
  };

  filterPosts = (filterType) => {
    this.setState({ filterType });
    this.fetchFeedData(filterType);
  };

  filterPostsAsPerFollowingTab = (filterType) => {
    this.fetchFeedData(filterType);
  };

  showHideNotifications = () => {
    this.setState({
      isNotificationSelected: !this.state.isNotificationSelected,
    });
  };

  //complete this method
  setShowData = (type) => {
    if (type === "ask") {
      this.fetchAllAsks();
    } else if (type === "tag") {
      this.fetchAllTags();
    }
    this.setState({ showData: type });
  };

  goBack = () => {
    this.setState({
      showData: "feed",
      searchData: {},
      clearSearchHeader: true,
    });
  };

  //related to handleSearchKeyDown method in header component
  fetchSearchData = async (params) => {
    this.setState({
      searchParam: params,
      showSearchPostPopup: true,
      clearSearchHeader: false,
    });
    // console.log("fetchSearchData invoked");
    // this.setState({ showData: "search", loading: true, searchParam: params });
    // try {
    //   const response = await API.getSearchData(params);
    //   this.setState({ searchData: response.data, loading: false });
    // } catch (e) {
    //   console.error(e);
    // } finally {
    //   this.setState({ loading: false });
    // }
  };

  onCloseSearchPostPopup = () => {
    this.setState({
      searchParam: "",
      showSearchPostPopup: false,
      clearSearchHeader: true,
    });
  };

  onUpdateSelection = (type) => {
    this.setState({ modalTypeForUpdate: type, showModalForUpdate: true });
  };

  hideUpdateModal = () => {
    this.setState({ showModalForUpdate: false });
  };
  handlePmRoleEmailAction = async () => {
    const { emailAction } = this.props;

    const response = await API.fetchLoginUser();
    const userDetails = response?.data;

    const loggedInEmail = userDetails?.userData?.userEmail
      ?.toLowerCase()
      ?.trim();

    const emailFromLink = emailAction?.emailId?.trim()?.toLowerCase();

    if (loggedInEmail && emailFromLink && loggedInEmail !== emailFromLink) {
      this.setState({
        pmRoleModalOpen: true,
        pmRoleModalMessage: `This moderator invitation was sent to ${emailFromLink}. Please sign in with that account to accept or reject the moderator role.`,
      });

      return;
    }

    try {
      const isPrimaryModerator =
        emailAction?.action === "acceptPMRole" ||
        emailAction?.action === "rejectPMRole";

      if (isPrimaryModerator) {
        // Primary Moderator API
        const status = emailAction?.action === "acceptPMRole" ? 1 : 0;

        const response = await API.primaryModeratorApproveDeny(
          emailAction?.tid,
          status,
        );

        this.setState({
          pmRoleModalOpen: true,
          pmRoleModalMessage:
            response?.data?.status ||
            response?.data?.message ||
            "Request processed successfully.",
        });
      } else {
        // Moderator API
        const loggedInUserId = userDetails?.userData?.User_ID;
        const tenantId = emailAction?.tid;

        const approveIdsValue =
          `user_${loggedInUserId}_${tenantId}_` +
          `${emailAction?.action === "acceptMRole" ? 1 : 0}`;

        const formData = new FormData();
        formData.append("approveIds", approveIdsValue);

        const response = await API.moderatorApproveDeny(formData);

        this.setState({
          pmRoleModalOpen: true,
          pmRoleModalMessage:
            response?.data?.status ||
            response?.data?.message ||
            "Request processed successfully.",
        });
      }
    } catch (error) {
      console.error("Role Action Error:", error);

      this.setState({
        pmRoleModalOpen: true,
        pmRoleModalMessage:
          error?.response?.data?.status ||
          error?.response?.data?.message ||
          error?.message ||
          "Something went wrong.",
      });
    }
  };
  handlePmRoleModalClose = () => {
    this.setState({
      pmRoleModalOpen: false,
      pmRoleModalMessage: "",
    });

    this.props.dispatchClearEmailAction();
  };

  handleInviteMismatchSignOut = () => {
    const { communityContext } = this.props;

    Cookies.remove("signInStatus");
    localStorage.setItem("logout-event", Date.now().toString());

    this.props.dispatchSignOut();

    communityContext?.onResetCommunity();

    console.log("Signed out from InviteFriend mismatch flow");
    console.log("InviteFriend Redux should remain:", this.props.emailAction);
  };

  handleInviteMismatchCancel = async () => {
    const { emailAction } = this.props;

    const communityId = emailAction?.tenantId
      ? Number(String(emailAction.tenantId).replace(/,/g, ""))
      : null;

    const communityName = emailAction?.tenantName?.trim() || null;

    if (!communityId || !communityName) {
      console.warn("Invalid InviteFriend community data:", emailAction);
      return;
    }

    try {
      // Close mismatch modal first
      this.setState({
        showInviteMismatchModal: false,
      });

      // Change to invited community
      await this.onCommunityChange(communityId, communityName);

      // Follow invited community
      const formdata = new FormData();
      formdata.append("communityID", communityId);
      formdata.append("communityName", communityName);
      formdata.append("followStat", 1);
      formdata.append("sourceApp", "WebApp");

      await API.followUnfollowCommunity(formdata);

      // Show follow success popup
      this.showFollowSuccessModal(communityName);
    } catch (error) {
      console.error("Error handling InviteFriend cancel:", error);
    }
  };

  handleEmailCommunityAction = async () => {
    const { emailAction, communityContext } = this.props;

    if (
      emailAction?.action !== "InviteFriend" &&
      emailAction?.action !== "redirectToCommunity"
    ) {
      return;
    }

    const communityId = emailAction?.tenantId
      ? Number(emailAction.tenantId)
      : null;

    const communityName = emailAction?.tenantName?.trim() || null;

    if (!communityId || !communityName) {
      console.warn("Invalid email community data:", emailAction);
      return;
    }

    try {
      // ---------------------------------------------------------
      // NEW: Only InviteFriend needs email comparison
      // redirectToCommunity does not need email comparison
      // ---------------------------------------------------------
      if (emailAction.action === "InviteFriend") {
        const response = await API.fetchLoginUser();
        const userDetails = response?.data;

        const invitedEmail = emailAction?.emailId?.toLowerCase()?.trim();

        const loggedInEmail = userDetails?.userData?.userEmail
          ?.toLowerCase()
          ?.trim();

        console.log("Invited email:", invitedEmail);
        console.log("Logged-in email:", loggedInEmail);

        if (invitedEmail && loggedInEmail && invitedEmail !== loggedInEmail) {
          this.setState({
            showInviteMismatchModal: true,
            invitedEmail,
            loggedInEmail,
          });

          return;
        }
      }
      // ---------------------------------------------------------
      // 1. Change/redirect to the community
      // ---------------------------------------------------------
      await this.onCommunityChange(communityId, communityName);

      // ---------------------------------------------------------
      // 2. Follow the community
      // InviteFriend requires the user to follow the community.
      // ---------------------------------------------------------

      if (emailAction.action === "InviteFriend") {
        const formdata = new FormData();

        formdata.append("communityID", communityId);
        formdata.append("communityName", communityName);
        formdata.append("followStat", 1);
        formdata.append("sourceApp", "WebApp");

        await API.followUnfollowCommunity(formdata);

        this.showFollowSuccessModal(communityName);
      }

      // ---------------------------------------------------------
      // 3. Clear email action so it doesn't execute again
      // ---------------------------------------------------------
      // this.props.dispatchClearEmailAction();

      console.log(`Email action handled successfully: ${emailAction.action}`);
    } catch (error) {
      console.error("Error handling email community action:", error);
    }
  };

  handleFollowHashtagEmailAction = async () => {
    const { emailAction } = this.props;

    if (emailAction?.action !== "followHashtag") {
      return;
    }

    try {
      // NEW: Get the community from the email link.
      // followHashtag uses redirectTenantId instead of tenantId.
      const communityId = emailAction?.redirectTenantId
        ? Number(emailAction.redirectTenantId)
        : null;

      // NEW: Get the community name from the email link.
      const communityName = emailAction?.tenantName?.trim() || null;

      if (communityId && communityName) {
        // NEW: Change to the community associated with the email
        // instead of keeping the user's default/current community.
        await this.onCommunityChange(communityId, communityName);
      }
      await API.fetchFollowUnfollowData(emailAction.messageId, "isFollow=1");

      this.setState({
        showFollowHashtagAlert: true,
      });
    } catch (error) {
      console.error("Error following hashtag:", error);
    }
  };
  handleFollowHashtagAlertClose = () => {
    this.setState(
      {
        showFollowHashtagAlert: false,
      },
      () => {
        this.props.dispatchClearEmailAction?.();
        this.fetchUserDetails();
      },
    );
  };

  fetchUserDetails = async () => {
    try {
      const response = await API.fetchLoginUser();
      const userDetails = response.data;
      const { location, communityContext } = this.props;
      const { setCommunityToDefault } = location?.state || {};
      const {
        tenantId,
        tenantRname,
        tenantName,
        defaultUserTenantId,
        defaultUserTenant,
      } = userDetails?.userData || {};
      if (setCommunityToDefault) {
        this.onCommunityChange(defaultUserTenantId, defaultUserTenant);
      } else {
        console.log("COMMMMMMM", communityContext);
        // first check context
        if (
          communityContext?.community?.tenantId &&
          communityContext?.community?.tenantName
        ) {
          const updatedTenantName =
            communityContext?.community?.tenantId === tenantId
              ? tenantRname
              : communityContext?.community?.tenantName;

          this.onCommunityChange(
            communityContext?.community?.tenantId,
            updatedTenantName,
          );
        } else {
          const tId = tenantId ? tenantId : defaultUserTenantId;
          const tName = tenantId ? tenantRname : defaultUserTenant;
          this.onCommunityChange(tId, tName);
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  getSaysListDataForAsks = async (page, id) => {
    try {
      const formdata = new FormData();
      formdata.append("id", id);
      const response = await API.fetchAsksSearchResultData(page, formdata);
      return response?.data?.messageList;
    } catch (e) {
      console.error(e);
    }
  };

  getAskListDataForSays = async (page, messageId) => {
    try {
      const formData = new FormData();
      formData.append("messageID", messageId);
      const response = await API.fetchAskListData(page, formData);
      return response?.data?.messageList;
    } catch (e) {
      console.error(e);
    }
  };

  fetchSaysDataForAsks = async (
    msg,
    latLong,
    locSelection,
    postingOption,
    attachment,
  ) => {
    try {
      this.setState({ possibleAsksAndAnswerLoading: true });
      let formdata = new FormData();
      formdata.append("Message", msg);
      if (attachment) {
        formdata.append("file", attachment);
      }
      const response = await API.fetchAsksData(
        formdata,
        latLong,
        locSelection,
        postingOption,
      );
      const possibleAnsList = await this.getSaysListDataForAsks(
        0,
        response?.data?.messageConnectionID,
      );
      this.setState({
        answersToYourAsk: {
          ...response.data,

          // Backend removed messageList from fetchAsksData API.
          // Fetching it separately from fetchAsksSearchResultData
          // and attaching it to maintain existing UI behavior.
          messageList: possibleAnsList || [],
        },
        possibleAsksAndAnswerLoading: false,
      });
    } catch (e) {
      console.error(e);
      this.setState({ possibleAsksAndAnswerLoading: false });
    }
  };

  fetchAsksToAnswer = async (
    msg,
    latLong,
    locSelection,
    postingOption,
    attachment,
  ) => {
    try {
      this.setState({ possibleAsksAndAnswerLoading: true });
      const { filterType } = this.state;
      let formdata = new FormData();
      formdata.append("Message", msg);
      if (attachment) {
        formdata.append("file", attachment);
      }
      const response = await API.fetchSaysData(
        formdata,
        latLong,
        locSelection,
        postingOption,
      );

      const possibleAskList = await this.getAskListDataForSays(
        0,
        response?.data?.messageId,
      );
      if (
        response?.data?.tenantSayStatus === "E" &&
        possibleAskList?.length === 0
      ) {
        alert(
          "Your SAY will publish as soon as the Community Moderator approves it.",
        );
      }
      // Backend removed messageList from fetchSaysData API.
      // Fetching it separately from success-say API and attaching it
      // to maintain existing UI behavior.
      // Pagination support will be added later.
      response.data.messageList = possibleAskList || [];
      this.setState({
        asksToBeAnswered: response.data,
        possibleAsksAndAnswerLoading: false,
      });
      //TODO: This should be removed when popup for says is shown
      //on clicking say community, this should be invoked similar to asks
      //Temporary fix
      //Later when subscription logic is added, it should handle assing new record
      //we should not fetch api again
      // if (response && (filterType === '' || filterType === 'say')) {
      //   this.fetchFeedData(filterType);
      // }
      // this.filterPosts("say");
      if (response?.data?.messageList?.length > 0) {
        this.filterPosts("");
      }
    } catch (e) {
      console.error(e);
      this.setState({ possibleAsksAndAnswerLoading: false });
    }
  };

  clearAsksAndSays = () => {
    this.setState({ asksToBeAnswered: {}, answersToYourAsk: {} });
  };

  onCommunityChange = async (id, name) => {
    const { selectedCommunity, showData, searchParam } = this.state;
    const { dispatchUserDetails, communityContext } = this.props;

    if (selectedCommunity?.tenantId !== id) {
      try {
        const response = await API.changeCommunity(name, id);
        this.setState({
          landApiData: response?.data,
          trendingTagBreadCountLength: 1,
          trendingAskBreadCountLength: 1,
          allAsks: [],
          allTags: [],
        });
        // update selectedCommunity data
        this.setState({
          selectedCommunity: {
            tenantName: name,
            tenantId: id,
          },
        });
        if (response) {
          this.setState(
            {
              // update selectedCommunity data
              selectedCommunity: {
                tenantName: name,
                tenantId: id,
              },
              //update others data
              feedPageNumber: 1,
              filterType: "",
              feedData: {},
              value: 0,
              showData: "feed",
            },
            () => {
              dispatchUserDetails();
              this.fetchIntialData();
              communityContext?.onChangeCommunity({
                tenantId: id,
                tenantName: name,
              });
            },
          );

          // if (showData === "tag" || showData === "ask" || showData === "search") {
          //   this.setState({ showData: "feed" });
          // }

          // dispatchUserDetails();
          // this.fetchIntialData();

          //why should we call logged in user, although community changes, logged in user is same
          // this.fetchLoggedInUser();
        }
      } catch (e) {
        console.error(e);
      }
      window.scrollTo(0, 0);
    }
  };

  // changeValue = (newValue) => {
  //   console.log(`newValue:`, newValue);
  //   this.setState({ value: newValue });
  // };
  changeValue = (newValue) => {
    console.log(`newValue:`, newValue);

    this.setState({ value: newValue }, () => {
      const { filterType } = this.state;
      if (newValue === 1) {
        if (filterType === "ask") {
          this.filterPostsAsPerFollowingTab("askfollowing");
        } else if (filterType === "hashtag") {
          this.filterPostsAsPerFollowingTab("hashtagfollowing");
        }
      } else {
        if (filterType === "ask") {
          this.filterPostsAsPerFollowingTab("ask");
        } else if (filterType === "hashtag") {
          this.filterPostsAsPerFollowingTab("hashtag");
        }
      }
    });
  };

  fetchChildSaysData = async (id, popCols, limit, startlimit = 0) => {
    this.setState({ childSaysLoading: true });
    try {
      const response = await API.fetchChildSaysData(
        id,
        popCols,
        limit,
        startlimit,
      );
      this.setState({ childSaysData: response.data, childSaysLoading: false });
    } catch (e) {
      this.setState({ childSaysLoading: false });
      console.error(e);
    }
  };

  postChildSayData = async (id, msg, lnglat, locSelect, attachment) => {
    try {
      let formdata = new FormData();
      formdata.append("Message", msg);
      if (attachment) {
        formdata.append("file", attachment);
      }
      const response = await API.postChildSayData(
        id,
        formdata,
        lnglat,
        locSelect,
      );
      const status = response?.data?.status || "";
      if (status === "New Hash") {
        return "New Hash";
      } else if (status === "E_Say" || status === "E") {
        this.setState({
          hasRestrictionSays: true,
          hasRestrictionSaysStatus: status,
        });
        return status;
      } else {
        this.fetchChildSaysData(id);
        if (
          this.state.showData === "tag" ||
          this.state.showData === "singleTrendingTag"
        ) {
          this.updateTagData(id, "add");
        } else if (this.state.showData === "ask") {
          this.updateAskData(id, "add");
        } else {
          this.updateFeedData(id, "add");
        }
        return status;
      }
    } catch (e) {
      console.error(e);
    }
  };

  resetHasRestrictionSays = () => {
    this.setState({ hasRestrictionSays: false, hasRestrictionSaysStatus: "" });
  };

  updateFeedData = (id, operator) => {
    // updating sayCount is the list based on operator
    // operator = 'add' | 'minus'
    const { feedData } = this.state;
    const feed = feedData?.feed || [];
    const copiedFeed = [...feed];
    const updatedFeed = copiedFeed.map((eachFeed) => {
      const isMatch = String(eachFeed?.id) === String(id);
      const currentCount = Number(eachFeed?.sayCount) || 0;
      const sayCount = isMatch
        ? operator === "add"
          ? currentCount + 1
          : Math.max(0, currentCount - 1)
        : eachFeed?.sayCount;
      return {
        ...eachFeed,
        sayCount,
      };
    });
    const updatedFeedData = { ...feedData, feed: updatedFeed };
    this.setState({ feedData: updatedFeedData });
  };

  updateTagData = (id, operator) => {
    // updating sayCount is the list based on operator
    // operator = 'add' | 'minus'
    const { allTags, selectedTagDetails, showData } = this.state;
    const copiedTags =
      showData === "singleTrendingTag" ? [...selectedTagDetails] : [...allTags];
    const updatedTags = copiedTags.map((eachTag) => {
      const isMatch = String(eachTag?.id) === String(id);
      const currentCount = Number(eachTag?.sayCount) || 0;
      const sayCount = isMatch
        ? operator === "add"
          ? currentCount + 1
          : Math.max(0, currentCount - 1)
        : eachTag?.sayCount;
      return {
        ...eachTag,
        sayCount,
      };
    });

    if (showData === "singleTrendingTag") {
      this.setState({ selectedTagDetails: [...updatedTags] });
    } else {
      this.setState({ allTags: [...updatedTags] });
    }
  };

  updateAskData = (id, operator) => {
    // updating sayCount is the list based on operator
    // operator = 'add' | 'minus'
    const { allAsks } = this.state;
    const copiedAsks = [...allAsks];
    const updatedAsks = copiedAsks.map((eachAsk) => {
      const isMatch = String(eachAsk?.id) === String(id);
      const currentCount = Number(eachAsk?.sayCount) || 0;
      const sayCount = isMatch
        ? operator === "add"
          ? currentCount + 1
          : Math.max(0, currentCount - 1)
        : eachAsk?.sayCount;
      return {
        ...eachAsk,
        sayCount,
      };
    });
    this.setState({ allAsks: [...updatedAsks] });
  };

  //this state variable is not used anywhere
  fetchFollowData = async (id, status) => {
    try {
      const response = await API.fetchFollowUnfollowData(id, status);
      this.setState({ followData: response.data });
    } catch (e) {
      console.error(e);
    }
  };

  //this state variable is not used anywhere
  fetchVoteUpStatus = async (id, status) => {
    try {
      const response = await API.fetchVoteUpStatus(id, status);
      this.setState({ voteUpStatus: response.data });
    } catch (e) {
      console.error(e);
    }
  };

  askYourCommunity = async (id) => {
    try {
      const res = await API.askYourCommunity(id);
      console.log(`res from home page of ask:`, res);
      return res;
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  fetchPrivateTagsData = async (id, limiter) => {
    try {
      const response = await API.fetchPrivateTagsData(id, limiter);
      this.setState({ privateTagsData: response.data });
    } catch (e) {
      console.error(e);
    }
  };

  //TODO: This method needs to be removed once subscription changes are added
  //The delete suscription should do something like this.
  deleteMessage = async (id, type, Parent_ID) => {
    const response = await API.deleteMessage(id);
    if (response) {
      const isAnswerOrReply =
        type === "Answer" ||
        type === "Reply" ||
        type === "ChildSay" ||
        type === "childSay" ||
        type === "W" ||
        type === "P" ||
        type?.toLowerCase?.() === "answer" ||
        type?.toLowerCase?.() === "reply";
      if (isAnswerOrReply) {
        const { childSaysData } = this.state;
        const updatedData = (childSaysData?.childSAYsMessageList || []).filter(
          (each) => String(each.id) !== String(id),
        );
        this.setState({
          childSaysData: {
            ...childSaysData,
            childSAYsMessageList: updatedData,
          },
        });
        if (
          this.state.showData === "tag" ||
          this.state.showData === "singleTrendingTag"
        ) {
          this.updateTagData(Parent_ID, "minus");
        } else if (this.state.showData === "ask") {
          this.updateAskData(Parent_ID, "minus");
        } else {
          this.updateFeedData(Parent_ID, "minus");
        }
      } else {
        const { showData } = this.state;
        if (showData === "feed") {
          const { feedData } = this.state;
          console.log("feedData", feedData, id, type);
          const newData = [...feedData.feed];
          const modifiedData = newData.filter((each) => each.id !== id);
          const updatedFeedData = {
            ...feedData,
            breadCountLength: modifiedData.length,
            feed: [...modifiedData],
          };
          console.log("modifiedData", modifiedData, newData, updatedFeedData);
          this.setState(
            {
              feedData: {
                ...updatedFeedData,
              },
            },
            console.log("this.state.feeddata", this.state.feedData),
          );
        } else if (showData === "ask") {
          const { allAsks } = this.state;
          const newData = [...allAsks];
          const modifiedData = newData.filter((each) => each.id !== id);
          this.setState({
            allAsks: modifiedData,
          });
        } else if (showData === "tag") {
          const { allTags } = this.state;
          const newData = [...allTags];
          const modifiedData = newData.filter((each) => each.id !== id);
          this.setState({
            allTags: modifiedData,
          });
        } else if (showData === "search") {
          const { searchData } = this.state;
          const newData = [...searchData.messageList];
          const modifiedData = newData.filter((each) => each.id !== id);
          this.setState({
            searchData: {
              ...searchData,
              totalList: modifiedData.length,
              messageList: modifiedData,
            },
          });
        }
      }
    }
  };

  refreshFeedData = (isChildPost, id) => {
    const { showData, filterType, searchParam } = this.state;
    console.log("refreshFeedData", showData, filterType, id, isChildPost);
    if (showData === "feed") {
      if (isChildPost) {
        this.fetchChildSaysData(id);
      } else {
        this.fetchFeedData(filterType);
      }
    } else if (showData === "tag") {
      if (isChildPost) {
        this.fetchChildSaysData(id);
      } else {
        this.fetchAllTags();
      }
    } else if (showData === "ask") {
      if (isChildPost) {
        this.fetchChildSaysData(id);
      } else {
        this.fetchAllAsks();
      }
    } else if (showData === "search") {
      if (isChildPost) {
        this.fetchChildSaysData(id);
      } else {
        this.fetchSearchData(searchParam);
      }
    }
  };

  getProps = () => {
    const {
      feedData,
      contributors,
      trendingAsks,
      trendingTags,
      allTags,
      allTagData,
      allAsks,
      userSettings,
      filterType,
      isNotificationSelected,
      showData,
      searchData,
      selectedTagDetails,
      showModalForUpdate,
      modalTypeForUpdate,
      selectedCommunity,
      childSaysData,
      followData,
      loading,
      answersToYourAsk,
      asksToBeAnswered,
      privateTagsData,
      childSaysLoading,
      feedPageNumber,
      value,
      hasRestrictionSays,
      hasRestrictionSaysStatus,
      clearSearchHeader,
      landApiData,
      hashMoreTrendingAsks,
      hasMoreTrendingTags,
      showSearchPostPopup,
      searchParam,
      possibleAsksAndAnswerLoading,
      showInviteMismatchModal,
      invitedEmail,
      loggedInEmail,
      followSuccessModal,
      followSuccessCommunityName,
      showFollowHashtagAlert,
      pmRoleModalOpen,
      pmRoleModalMessage,
    } = this.state;
    return {
      loading,
      feedData,
      contributors,
      trendingAsks,
      trendingTags,
      allTags,
      allTagData,
      allAsks,
      userSettings,
      filterType,
      isNotificationSelected,
      clearSearchHeader,
      showData,
      searchData,
      selectedTagDetails,
      showModalForUpdate,
      modalTypeForUpdate,
      selectedCommunity,
      childSaysData,
      followData,
      answersToYourAsk,
      asksToBeAnswered,
      privateTagsData,
      childSaysLoading,
      feedPageNumber,
      value,
      hasRestrictionSays,
      hasRestrictionSaysStatus,
      landApiData,
      hashMoreTrendingAsks,
      hasMoreTrendingTags,
      showSearchPostPopup,
      searchParam,
      possibleAsksAndAnswerLoading,
      showInviteMismatchModal,
      invitedEmail,
      loggedInEmail,
      followSuccessModal,
      followSuccessCommunityName,
      showFollowHashtagAlert,
      pmRoleModalOpen,
      pmRoleModalMessage,
      handlePmRoleModalClose: this.handlePmRoleModalClose,
      handleFollowSuccessModalClose: this.handleFollowSuccessModalClose,
      handleFollowHashtagAlertClose: this.handleFollowHashtagAlertClose,
      handleInviteMismatchCancel: this.handleInviteMismatchCancel,
      handleInviteMismatchSignOut: this.handleInviteMismatchSignOut,
      onCloseSearchPostPopup: this.onCloseSearchPostPopup,
      resetHasRestrictionSays: this.resetHasRestrictionSays,
      showHideNotifications: this.showHideNotifications,
      fetchUserSettings: this.fetchUserSettings,
      filterPosts: this.filterPosts,
      fetchSelectedTagDetails: this.fetchSelectedTagDetails,
      setShowData: this.setShowData,
      goBack: this.goBack,
      onUpdateSelection: this.onUpdateSelection,
      hideUpdateModal: this.hideUpdateModal,
      fetchSearchData: this.fetchSearchData,
      onCommunityChange: this.onCommunityChange,
      fetchChildSaysData: this.fetchChildSaysData,
      postChildSayData: this.postChildSayData,
      fetchFollowData: this.fetchFollowData,
      fetchVoteUpStatus: this.fetchVoteUpStatus,
      fetchSaysDataForAsks: this.fetchSaysDataForAsks,
      fetchAsksToAnswer: this.fetchAsksToAnswer,
      askYourCommunity: this.askYourCommunity,
      fetchFeedData: this.fetchFeedData,
      fetchPrivateTagsData: this.fetchPrivateTagsData,
      deleteMessage: this.deleteMessage,
      refreshFeedData: this.refreshFeedData,
      fetchPageFeed: this.fetchPageFeed,
      changeValue: this.changeValue,
      clearAsksAndSays: this.clearAsksAndSays,
      deleteAnswersToAsksDialogPost: this.deleteAnswersToAsksDialogPost,
      deletePossibleAnswerToAskPost: this.deletePossibleAnswerToAskPost,
      deleteAsksToBeAnsweredDialogPost: this.deleteAsksToBeAnsweredDialogPost,
      fetchContributors: this.fetchContributors,
      updateTrendingAskPageCount: this.updateTrendingAskPageCount,
      updateTrendingTagPageCount: this.updateTrendingTagPageCount,
    };
  };

  render() {
    const viewProps = this.getProps();

    return <ViewRenderer {...viewProps} />;
  }
}

const mapDispatchToProps = (dispatch) => ({
  dispatchUserDetails: () => {
    dispatch(SignInActions.fetchloginUser());
  },
  dispatchSettings: () => {
    dispatch(feedActions.fetchSettings());
  },
  dispatchClearEmailAction: () => {
    dispatch(clearEmailAction());
  },
  dispatchSignOut: () => {
    dispatch(SigInOutActions.signOut());
  },
  // dispatchNotifications: (data) => {
  //   dispatch(notificationActions.receiveNotificationData(data))
  // }
});

const mapStateToProps = (state) => {
  const { userDetails, landApiData } = state.SignInReducer;
  const { settingsData } = state.voteupReducer;
  return {
    userDetails,
    settingsData,
    signInLandApiData: landApiData,
    emailAction: state.emailActionReducer,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withCommunity(Home));
